import "./Editorial.scss";
import { editorialFacultyData } from "./editorialData";


const Editorial = () => {
    return (
        <section className="editorialMainContainer">
            {editorialFacultyData.map((facultyData, index) => (
                <div
                    key={facultyData.name} 
                    className="facultyDataParent"
                    style={{ flexDirection: index % 2 !== 0 ? "row-reverse" : "row" }}
                >
                    {facultyData.image && (
                        <div className="facultyImageParent">
                            <img
                                src={facultyData.image}
                                alt={`Image of ${facultyData.name}`}
                                className="facultyImage"
                            />
                        </div>
                    )}
                    <div className="facultyDetails">
                        <h2>{facultyData.role}</h2>
                        {facultyData.details.map((point, index) => (
                            <p key={index}>{point}</p>
                        ))}
                    </div>
                </div>
            ))}
            <br>
            </br>

             <p style={{fontFamily:"Gilroy-Medium",fontSize:"clamp(1rem, 1.3vw, 1.2rem)",cursor:"pointer",color:"blue"}} onClick={()=>window.open("/reviewers.pdf","_blank")}>
            Click to view more editorial members...
</p>
        </section>
    );
};

export default Editorial;
